// extracted by mini-css-extract-plugin
export default {"documentColumn":"TableProduct_documentColumn__kmrlk","productName":"TableProduct_productName__Sad3f","image":"TableProduct_image__C-qhf"};